<script setup lang="ts">
import { CardFaq } from "@/components/Cards";
import { Section } from "@/components/Ui";

interface Props {
  faqItems: any;
  sectionTitleClass?: any;
  sectionClass?: any;
}
const props = defineProps<Props>();
</script>

<template>
  <Section
    v-if="faqItems.length"
    :title-class="props.sectionTitleClass"
    :class="props.sectionClass"
    full-width
  >
    <template #title>
      FAQ
    </template>
    <CardFaq :items="props.faqItems" class="container w-full" />
  </Section>
</template>